import { createFileRoute } from '@tanstack/react-router'
import { useSignI18n } from '../lib/locale'

export const Route = createFileRoute('/')({ component: Home })

/** The bare domain carries no token, so it can only explain itself. */
function Home() {
  const { t } = useSignI18n()

  return (
    <section className="flex flex-col gap-3">
      <h1 className="font-semibold text-display text-ink">{t('home.title')}</h1>
      <p className="text-body text-muted">{t('app.tagline')}</p>
      <p className="text-body text-ink">{t('home.body')}</p>
    </section>
  )
}
